module.exports = __webpack_public_path__ + "static/media/arrow-up.b00f8de8.svg";